
import { ErrorsTranslationType } from "../../features/errors.types";

export const errors: ErrorsTranslationType = {
  errors: {
    error: "Error",
    notFound: "Page not found",
    deleteAccountError: "There was an error deleting your account. Please try again.",
    loadStoryError: "Failed to load the story. Please try again.",
    loadCharactersError: "Failed to load characters. Please try again.",
    summaryError: "Error generating summary. Please try again."
  }
};
